module.exports = __webpack_public_path__ + "img/GDQ-matcirkel_80.901e6d2e.gif";